/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  const storeDomain = 'thelittleroseshop.com';
  const links = document.links;

  for (let i = 0, linksLength = links.length; i < linksLength; i++) {
    const link = links[i];
    const href = link.href;

    // Skip if no href
    if (!href) continue;

    // Get existing rel values
    const existingRel = link.rel ? link.rel.split(' ') : [];
    let newRel = [];

    // Check if it's an external link
    if (link.hostname !== window.location.hostname 
        && !href.startsWith('/') 
        && !href.includes(storeDomain) 
        && !href.includes('myshopify.com')) {
      // External link - add nofollow, noreferrer, noopener
      newRel = ['nofollow', 'noreferrer', 'noopener'];
      link.target = '_blank';
    } else {
      // Internal link - only add noreferrer, noopener
      newRel = ['noreferrer', 'noopener'];
    }

    // Combine existing and new rel values, remove duplicates
    const finalRel = [...new Set([...existingRel, ...newRel])].join(' ');
    link.rel = finalRel;
  }

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
